import { paths } from "helpers/paths";
import React from "react";
import { Route, Switch } from "react-router-dom";
import * as pointsSource from "sources/books/counterpartyPoints";
import PointForm from "./form";
import PointsList from "./list";

const CounterpartyPoints = (props) => {
    const backToPoints = (counterpartyId) => history.push(paths.counterpartyPoints(counterpartyId));
    const { match, history } = props;
    const { counterpartyId } = match.params;
    const back = () => history.push(paths.cargoOwnersShow(counterpartyId));
    return (
        <Switch>
            <Route
                exact
                path={`${match.path}/new`}
                render={(rest) => (
                    <PointForm {...rest} back={() => backToPoints(counterpartyId)} source={pointsSource} />
                )}
            />
            <Route
                exact
                path={`${match.path}/:id`}
                render={(rest) => (
                    <PointForm {...rest} back={() => backToPoints(counterpartyId)} source={pointsSource} />
                )}
            />
            <Route path={match.path} render={(rest) => <PointsList {...rest} back={back} source={pointsSource} />} />
        </Switch>
    );
};

export default CounterpartyPoints;
